export const Bio = {
  name: "Animesh Raghav",
  roles: [
    "Full Stack Developer",
    "Java Developer",
    "Python Developer",
    "UI/UX Designer",
    // "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/animeshraghav",
  resume: "https://drive.google.com/file/d/1l1qbb7g1YrDooOgvd3j1HpVutrzze9Jd/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/animesh-raghav/",
  // twitter: 
  insta: "https://www.instagram.com/animesh_raghav/",
  // facebook: 
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "/images/reactjs.png",
      },
      // {
      //   name: "Redux",
      //   image:
      //     "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      // },
      {
        name: "Next Js",
        image:
          "/images/nextjs.png",
      },
      {
        name: "HTML",
        image: "/images/html.png",
      },
      {
        name: "CSS",
        image:
          "/images/css.png",
      },
      {
        name: "JavaScript",
        image:
          "/images/js.png",
      },
      // {
      //   name: "Bootstrap",
      //   image:
      //     "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      // },
      {
        name: "Material UI",
        image:
          "/images/materialui.png",
      },
      // {
      //   name: "Flutter",
      //   image:
      //     "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      // },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://raw.githubusercontent.com/devicons/devicon/55609aa5bd817ff167afce0d965585c92040787a/icons/nodejs/nodejs-plain-wordmark.svg",
      },
      {
        name: "Express Js",
        image:
          "/images/expressjs.png",
      },
      {
        name: "Java",
        image: "/images/java.png",
      },
      {
        name: "Python",
        image:
          "/images/python.png",
      },
      {
        name: "MySQL",
        image:
          "/images/mysql.png",
      },
      // {
      //   name: "Postgresql",
      //   image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      // },
      {
        name: "MongoDB",
        image:
          "/images/mongodb.png",
      },
      // {
      //   name: "Firebase",
      //   image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      // },
    ],
  },
  // {
  //   title: "Android",
  //   skills: [
  //     {
  //       name: "Java",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
  //     },
  //     {
  //       name: "Kotlin",
  //       image:
  //         "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
  //     },
  //     {
  //       name: "XML",
  //       image:
  //         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
  //     },
  //     {
  //       name: "Android Studio",
  //       image:
  //         "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
  //     },
  //   ],
  // },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "/images/git.png",
      },
      {
        name: "GitHub",
        image:
          "/images/github.png",
      },
      // {
      //   name: "Docker",
      //   image:
      //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      // },
      // {
      //   name: "Netlify",
      //   image:
      //     "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      // },
      {
        name: "VS Code",
        image:
          "/images/vscode.png",
      },
      {
        name: "Postman",
        image:
          "/images/postman.png",
      },
      {
        name: "Adobe Photoshop",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/55609aa5bd817ff167afce0d965585c92040787a/icons/photoshop/photoshop-plain.svg",
      },
      {
        name: "Adobe Premiere pro",
        image:
          "/images/premierepro.png",
      },
      {
        name: "Adobe Lightroom",
        image:
          "/images/lightroom.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "/images/ethnus.jpeg",
    role: "MERN Full Stack development Intern",
    company: "Ethnus Pvt. Ltd.",
    date: "Aug 2023 - Nov 2023",
    desc: "Working on Flipr Platforms, managing DevOps, and streamlining the process with automation.",
    skills: [
      "Docker",
      "Terraform",
      "AWS",
      "EC2",
      "Portainer",
      "Nginx",
      "JavaScript",
      "TypeScript",
      "Node Js",
      " Next Js",
    ],
    doc: "https://www.linkedin.com/in/animesh-raghav/details/certifications/1635554200592/single-media-viewer/?type=DOCUMENT&profileId=ACoAADa5JjkBvqhvYzPdYZTRLmLLfWIAoGOPRD4",
  },
  {
    id: 1,
    img: "/images/letsgrowmore.jpeg",
    role: "Web Development Intern",
    company: "Let's Grow More",
    date: "September 2023",
    desc: "Working on the frontend of the web application using ReactJS, Redux, and Material UI.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
    ],
    doc: "https://www.linkedin.com/in/animesh-raghav/details/certifications/",
  },
];

export const education = [
  {
    id: 0,
    img: "/images/vit.jpg",
    school: "Vellore Institute of Technology, Bhopal",
    date: "Oct 2020 - Sep 2025",
    grade: "8.68 CGPA",
    desc: "I am currently pursuing Integrated Master's degree in Artificial Intelligence and Machine Learning at VIT, Bhopal . I have completed 8 semesters and have a CGPA of 8.45. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Photography club at VIT, where I am learning and working with the talented team to showcase the photography skills in vision to promote university",
    degree: "Integrated Masters of Technology with specialization in (Artificial Intelligence and Machine Learning)",
  },
  {
    id: 1,
    img: "/images/Sanskar.jpeg",
    school: "Sanskar The Co-Educational School",
    date: "April 2019",
    grade: "75%",
    desc: "I completed my class 12 high school education at Sanskar The Co-Educational School, where I studied Science with Computer Science.",
    // degree: "ISC(XII), Science with Computer",
  },
  {
    id: 2,
    img: "/images/Sanskar.jpeg",
    school: "Sanskar The Co-Educational School",
    date: "April 2017",
    grade: "9.6/10",
    desc: "I completed my class 10 education at Sanskar The Co-Educational School, where I studied Science with Computer Application.",
    // degree: "ICSC(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 0,
    title: "Digit Recognition",
    date: "August 2021 - October 2021",
    description:
      "Trackify is a web application designed to streamline task management and enhance productivity in the workplace. It provides a user-friendly interface for employers to keep track of their employees' daily work activities and empowers employees to log their tasks efficiently. \nAdmin Credentials: # Email: testadmin@gmail.com #Password- 123@testadmin, Employee Credentials:	#Email: testemployee@gmail.com	#Password- 123@Testemployee",
    // image:
    //   "https://user-images.githubusercontent.com/64485885/255202416-e1f89b04-2788-45b0-abc2-9dec616669e2.png",
    tags: [],
    category: "machine learning",
    github: "https://github.com/animeshraghav/Digit-Recognition",
    // webapp: "https://trackify.duckdns.org",
  },
  {
    id: 1,
    title: "Movie recommender",
    date: "Dec 2021 - Mar 2022",
    description:
      "Designed and developed the Vexa project, a project management app that helps users and teams stay organized and on track. Implemented key features such as task tracking, team collaboration, and time tracking to improve productivity and project outcomes and also invite team/project members. The plan is to add a community of users where they can find developers and other team members and chat system implementation.",
    // image:
    //   "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "NodeMailer",
    ],
    category: "machine learning",
    github: "https://github.com/animeshraghav/Movie-Recommendation-system",
    // webapp: "https://vexa-app.netlify.app/",
  },
  {
    id: 2,
    title: "Job Portal",
    date: "Aug 2023 - Nov 2023",
    description:
      "Designed and developed the Vexa project, a project management app that helps users and teams stay organized and on track. Implemented key features such as task tracking, team collaboration, and time tracking to improve productivity and project outcomes and also invite team/project members. The plan is to add a community of users where they can find developers and other team members and chat system implementation.",
    image:
      "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "NodeMailer",
    ],
    category: "web app",
    github: "https://github.com/animeshraghav/Job-portal",
    // webapp: "https://vexa-app.netlify.app/",
  },
  {
    id: 3,
    title: "Miniature Booking Application",
    date: "December 2023 - ongoing",
    description:
      "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
    image:
      "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
    tags: ["Go"],
    category: "machine learning",
    github: "https://github.com/animeshraghav/Booking-application",
    // webapp: "https://brain-tumor.netlify.app/",
  },
  {
    id: 4,
    title: "Whatsapp Clone",
    date: "Jul 2021",
    description:
      "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
    tags: ["React Js", "Firebase", "Firestore", "Node JS"],
    category: "web app",
    github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
    webapp: "https://whatsapp-clone-rishav.web.app",
  },
  {
    id: 5,
    title: "Todo Web App",
    date: "September 2023",
    description:
      "The 'TO-DO LIST web app' is a minimalistic project built using only HTML, CSS, and JavaScript. Users can effortlessly input and organize their tasks, with the flexibility to mark items as completed or delete them at their convenience. The web app offers a user-friendly interface with a dual-theme feature, allowing users to switch between dark and light modes via a toggle button. Additionally, an interactive 'ADD' button enhances user experience by expanding upon hover, providing an aesthetically pleasing and functional means of adding new tasks. This project demonstrates the simplicity and effectiveness of HTML, CSS, and JavaScript in creating a visually appealing and intuitive task lisiting solution.",
    image:
      "/images/TO-DO LIST WEBAPP.png",
    tags: ["Javascript", "CSS", "HTML"],
    category: "web app",
    github: "https://github.com/animeshraghav/To-Do-list-Web-App",
    webapp: "https://animeshraghav.github.io/To-Do-list-Web-App/",
  },
  {
    id: 6,
    title: "SR-GAN Image upsampling",
    date: "August 2023 - October 2023",
    description:
      "Super-Resolution Generative Adversarial Network is a powerful method used for enhancing the resolution of images, transforming low-resolution inputs into high-resolution outputs with remarkable detail. It combines the strengths of convolutional neural networks and adversarial training to achieve state-of-the-art performance in image super-resolution tasks.",
    image:
      "/images/sr-gan image upsampling.png",
    tags: ["Generative AI", "Python", "OpenCV", "TensorFlow", "CNN", "VGG16", "Jupyter Notebook"],
    category: "machine learning",
    github: "https://github.com/animeshraghav/SR-GAN-Image-upsampling",
    // webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  },
];

// ... existing code ...

export const projectsHeader = {
  title: "Projects",
  desc: "I have worked on a wide range of projects. From web apps to android apps. Here are some of my projects."
};

export const skillsHeader = {
  title: "Skills",
  desc: "Here are some of my skills on which I have been working on for the past 2 years."
};

export const contact = {
  title: "Contact Me",
  desc: "Feel free to reach out to me for any questions or opportunities!",
  emailjs_service_id: 'service_p0yu5ue',
  emailjs_template_id: 'template_5pcocsa',
  emailjs_public_key: 'yP4D3U6f0F4Pou2Jt'
};

export const footer = {
  copyright: "© 2024 Animesh Raghav. All rights reserved."
};
